import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import './Login.css';

export const Login: React.FC = () => {
  const { signIn, signUp, loading } = useAuth();
  const { showToast } = useToast();
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (isSignUp) {
        await signUp(email, password);
        showToast('Conta criada com sucesso! Faça login para continuar.', 'success');
        setIsSignUp(false);
      } else {
        await signIn(email, password);
        showToast('Login realizado com sucesso!', 'success');
      }
    } catch (error: any) {
      showToast(error.message || 'Erro ao autenticar', 'error');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto"></div>
          <p className="mt-4 text-text-secondary">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-image">
        <div className="image-overlay">
          <div className="welcome-text">
            <h1>Bem-vindo ao</h1>
            <h2>Hollos Novos Contratos</h2>
            <p>Sistema gestão de leads</p>
          </div>
        </div>
      </div>

      <div className="login-form-container">
        <div className="login-form-wrapper">
          <div className="login-logo">
            <img src="/assets/images/LOGO_HOLLOS.png" alt="Hollos Logo" />
          </div>

          <div className="login-header">
            <h1>{isSignUp ? 'Criar Conta' : 'Acesse sua conta'}</h1>
            <p>{isSignUp ? 'Preencha os dados para criar sua conta' : 'Entre com suas credenciais para continuar'}</p>
          </div>

          <form id="login-form" className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">{isSignUp ? 'Email' : 'Usuário'}</label>
              <div className="input-wrapper">
                <i className="fas fa-user"></i>
                <input
                  type={isSignUp ? 'email' : 'text'}
                  id="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={isSignUp ? 'seu@email.com' : 'Digite seu usuário'}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Senha</label>
              <div className="input-wrapper">
                <i className="fas fa-lock"></i>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Digite sua senha"
                  required
                  minLength={6}
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={togglePasswordVisibility}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            {!isSignUp && (
              <div className="form-options">
                <label className="checkbox-wrapper">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span>Lembrar-me</span>
                </label>
              </div>
            )}

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-sign-in-alt"></i> {isSignUp ? 'Criar Conta' : 'Entrar'}
              </button>
            </div>
          </form>

          <div className="login-footer">
            <button
              type="button"
              onClick={() => setIsSignUp(!isSignUp)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--colors-primary)',
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: '0.9rem',
                fontFamily: 'var(--font-family)',
              }}
            >
              {isSignUp ? 'Já tem conta? Faça login' : 'Não tem conta? Criar conta'}
            </button>
          </div>

          <div style={{
            textAlign: 'center',
            paddingTop: '1.5rem',
            borderTop: '1px solid var(--colors-fog)',
            marginTop: '1.5rem',
          }}>
            <p style={{
              fontSize: '0.85rem',
              color: 'var(--colors-graphite)',
              fontFamily: 'var(--font-family)',
              margin: 0,
            }}>© 2026 Hollos CRM. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
